fx.ns("filters", class LayoutThemeFilter extends fx.Filter {

	constructor(themeid, theme_tag_id, themes, search, labels, showMinAndMore, is3D)
	{
        super();
        this._themes = themes;
        this._themeid = themeid;
        this._theme_tag_id = theme_tag_id;
        this._search = search || "recommended";
        this._labels = labels == undefined ? true : labels;
        this._showMinAndMore = showMinAndMore;
        this._is3D = is3D;

        this._sortThemeAndNumPhotosHandler = this._sortThemeAndNumPhotos.bind(this);
        this._sortThemeHandler = this._sortTheme.bind(this);
    }

    get themes()
    {
        return this._themes;
    }

    set themes(val)
    {
        this._themes = val;
        this._changed = true;
        this.trigger("updated");
    }

    get accountid()
    {

    }

    set accountid(val)
    {
        this._accountid = val;
        ///
        this.trigger("updated");
    }

    get themeid()
    {
        return this._themeid;
    }

    set themeid(val)
    {
        if (this._themeid == val)
            return;

        this._themeid = val;
        this._changed = true;
        this.trigger("updated");
    }

    get theme_tag_id()
    {
        return this._theme_tag_id;
    }

    set theme_tag_id(val)
    {
        if (this._theme_tag_id == val)
            return;

        this._theme_tag_id = val;
        this._changed = true;
        this.trigger("updated");
    }

    get search()
    {
        return this._search;
    }

    set search(val)
    {
        if (this._search == val)
            return;

        this._search = val;
        this._changed = true;
        this.trigger("updated");
    }

    get labels()
    {
        return this._labels;
    }

    set labels(val)
    {
        if (this._labels == val)
            return;

        this._labels = val;
        this._changed = true;
        this.trigger("updated");
    }

	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        let currentThemeId = -1;
        
        let rawData/*, accountAdded*/;
        if (this.search == "custom")
            rawData = this.rawData.sort(function(a, b){ return a.accountid - b.accountid });
        else
            rawData = this.rawData.sort(this._sortThemeHandler);

        if (this.search == "recommended" && (fx.browser.isMobile || fx.browser.isTablet))
            rawData = this._uniqueLayouts(rawData);
            
        for (let i = 0; i < rawData.length; i++)
        {
            let layout = rawData.getItemAt(i);

            if (this._is3D)
            {     
                if ( layout.num_photos == 1 && layout.themeid ==-1 && !layout.accountid && layout.target == "")
                this.transformedData.push( layout );

                continue;
            }

            let layoutTheme = this._getLayoutTheme(layout);
            
            if (this.search == "custom")
            {
                if (layout.themeid == -1 && layout.accountid)
                {
                    this.transformedData.push( layout );
                }
            }
            else
            {
                if (this.search == "recommended")
                {
                    if (fx.browser.isMobile || fx.browser.isTablet)
                    {
                        if (layoutTheme && layoutTheme.id == this.themeid && layout.typeid == 1)
                            this.transformedData.push( layout );
                    }    
                    else
                    if(layoutTheme && layoutTheme.theme_tag_id == this.theme_tag_id && !layout.doublepage && layout.typeid == 1) // if layout is linked to a theme and is not a double page layout
                    {
                        if (layout.themeid != currentThemeId)
                        {
                            if (this.labels)
                                this.transformedData.push( {type : "label", text : fx.text("Modèles") + " " + layoutTheme.name}  );

                            currentThemeId = layout.themeid;
                        }
                        this.transformedData.push( layout );
                    }
                }
                else
                if (this._showMinAndMore)
                {
                    let num = (this.search > 4) ? 4 : this.search;

                    if ( layout.num_photos >= num && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
                else
                if (this.search == 1)
                {
                    if ( layout.num_photos <= 1 && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
                else
                if (this.search == "+")
                {
                    if ( layout.num_photos > 4 && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
                else
                if (this.search > 1 && this.search != "+")
                {
                
                    if ( layout.num_photos == this._search && layout.themeid == -1 && !layout.accountid && layout.target == "")
                        this.transformedData.push( layout );
                }
                else
                    this.transformedData.push( layout );
            }
        }

        if (this._showMinAndMore)
            return this.transformedData.sort(this._sortThemeAndNumPhotosHandler);
        
        this.transformedData.more = (this.search == "recommended") ? this.rawData.more : false;

		return this.transformedData;
	}	

    _sortTheme(a, b)
    {
        return (a.themeid != this.themeid) - (b.themeid != this.themeid)
    }

    _sortThemeAndNumPhotos(a,b)
    {
        if (a.themeid == this.themeid && b.themeid == this.themeid)
            return a.num_photos - b.num_photos;
        else
        if (a.themeid == this.themeid && b.themeid != this.themeid)
            return -1;
        else
        if (a.themeid != this.themeid && b.themeid == this.themeid)
            return 1;
        else
            return a.num_photos - b.num_photos;
    }

    _getLayoutTheme(layout)
    {
        if(this._themes)
        {
            for (let i = 0; i < this._themes.length; i++)
            {
                if (layout.themeid == this._themes.getItemAt(i).id)
                    return this._themes.getItemAt(i);
            }
        }
        return null;
    }


    _uniqueLayouts( layouts )
    {
        let uniqueLayouts = [];
        const seenLayouts = new Set();
    
        layouts.forEach(layout => {

            if (layout.doublepage)
                return;

            let components = layout.components.sort( (a, b) => a.x - b.x || a.y - b.y );

            let key = "";
            components.forEach( component => {
                if (component.component_type != "background")
                    key += `${Math.round(component.x)}|${Math.round(component.y)}|${Math.round(component.width)}|${Math.round(component.height)}|`;
            });

            if (!seenLayouts.has(key)) {
                seenLayouts.add(key);
                uniqueLayouts.push(layout);
            }
        });

        return uniqueLayouts;
    }
});